export default __webpack_public_path__ + "static/media/lamp.ec65f483.png";